<div class="section__item">
  <mat-form-field>
    <input matInput type="text" [formControl]="control">
  </mat-form-field>
  <button mat-icon-button color="primary" (click)="delete()">
    <mat-icon>delete</mat-icon>
  </button>
</div>
